<template>
  <div class="general-info">
    <div class="general-info__container">
      <div class="general-info__row">
        <div v-if="showDynamicMenu" class="floating-menu">
          <DynamicMenu :menu-items="dynamicMenuItems" :current-slug="linksDepartment"/>
        </div>
        <div class="general-info__column">
          <div class="general-info__title">
            <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">Вакансии</h1>
          </div>
          <div class="general-info__block-row">
            <AppVacancyItem v-for="vacancy in firstOneVacancies" :key="vacancy.id" :item_vacancy="vacancy" class="" />
          </div>
        </div>
      </div>
      <div class="">
        <AppVacancyItem v-for="vacancy in remainingVacancies" :key="vacancy.id" :item_vacancy="vacancy" class="vacancy__item" />
      </div>
    </div>
  </div>
</template>

<script>
import AppVacancyItem from '@/components/Vacancies/VacancyItem.vue'
import {actionTypesVacancies} from '@/store/modules/vacancies'
import {mapState} from 'vuex'
import DynamicMenu from "@/components/DynamicMenu.vue";
import menuItemsApi from "@/api/menuItems";

export default {
    name: "AppVacancies",
    components: {DynamicMenu, AppVacancyItem},
    metaInfo() {
      return {
        title: 'Вакансии | Алтайский краевой клинический перинатальный центр ДАР',
        meta: [
          {
            name: 'description',
            content: 'Вакансии. Подробная информация о Алтайском краевом клиническом перинатальном центре ДАР.'
          },
          {
            name: 'keywords',
            content: 'Алтайский краевой клинический перинатальный центр'
          }
        ]
      };
    },
    data() {
      return {
        linksDepartment: 'about/vacancies',
        dynamicMenuItems: [],
      }
    },
    computed: {
      ...mapState({
        isLoading: (state) => state.vacancies.isLoading,
        vacancies: (state) => state.vacancies.vacancies,
      }),
      firstOneVacancies() {
        return this.vacancies.slice(0, 1);
      },
      remainingVacancies() {
        return this.vacancies.slice(1);
      },
      showDynamicMenu() {
        return this.dynamicMenuItems && this.dynamicMenuItems.length > 0;
      }
    },
    methods: {
      async loadSiblingsForMenu() {
        try {
          const response = await menuItemsApi.getSiblingsByTo('/about/vacancies');

          if (response.data.status === "SUCCESS") {
            this.dynamicMenuItems = response.data.result
                .map(item => {
                  const slug = item.to.startsWith('/') ? item.to.substring(1) : item.to;

                  return {
                    text: item.label,
                    link: item.to,
                    slug: slug,
                    active: slug === this.currentPath,
                    id: item.id,
                    order: item.order || 0
                  };
                })
                .sort((a, b) => (a.order || 0) - (b.order || 0));
          }
        } catch (error) {
          console.error('Ошибка при загрузке меню:', error);
        }
      }
    },
    mounted() {
      this.$store.dispatch(actionTypesVacancies.getVacancies)
          .then(() => {

          })
          .catch((er) => {
            console.log("Ошибка", er);
          });
      this.loadSiblingsForMenu();
    }
  };
</script>

<style scoped>

</style>
